import { CellContext } from '@tanstack/react-table';
import { toast } from 'react-toastify';
import { IDataTableRef } from 'src/components/DataTable/shared/types';
import useAcceptFlashDiscount from '../services/hooks/use-accept-flash-discount';
import { FlashDiscountProductListItem } from '../services/models/flash-discount';

interface IProps {
  cellContext: CellContext<FlashDiscountProductListItem, unknown>;
  dataTableRef: React.RefObject<IDataTableRef>;
}

export default function FlashProductsActionCell(props: IProps) {
  const { dataTableRef, cellContext: ctx } = props;

  const { mutate } = useAcceptFlashDiscount({
    onMutate: () => {
      ctx?.table?.options?.meta?.setTableTempData?.({
        loading: true,
      });
    },
    onSuccess: () => {
      dataTableRef.current?.resetPagination?.();
      ctx?.table?.options?.meta?.invalidateDataTableQuery?.();
      ctx?.table?.options?.meta?.clearTableTempData?.();

      toast.success('İşleminiz başarıyla tamamlandı.');
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || 'İşleminiz sırasında bir hata oluştu.');
    },
    onSettled: () => {
      ctx?.table?.options?.meta?.setTableTempData?.({
        loading: false,
      });
    },
  });

  const tableTempData = ctx?.table?.options?.meta?.getTableTempData?.({}) || {};

  const { selectedRowId = null, selectedPeriodId = null, editPriceData = {}, loading = false } = tableTempData;

  const rowId = ctx?.row?.original?.id || ctx?.row?.id;

  const disabled = !selectedRowId || !selectedPeriodId || selectedRowId !== rowId || !editPriceData?.isValid || loading;

  return (
    <div className="d-flex flex-column justify-content-center">
      <button
        className="btn btn-sm btn-primary w-150px d-flex align-items-center justify-content-center gap-2"
        disabled={disabled}
        onClick={(e) => {
          if (disabled) {
            e?.stopPropagation?.();
            return e?.preventDefault?.();
          }

          mutate({
            acceptedFlashDiscountId: selectedPeriodId,
            acceptedPrice: editPriceData.price,
          });
        }}
      >
        {loading && rowId === selectedRowId ? <span className="spinner-border spinner-border-sm" /> : null}
        <span>Fiyatı Güncelle</span>
      </button>
    </div>
  );
}
